import React from 'react';
import { PiPlant, PiTractor } from 'react-icons/pi';

import { Tooltip } from 'antd';
import {
  COPY_TOOL_GROUP_BY_ARIA_LABEL,
  TREE_GROUP_BY_CROP,
  TREE_GROUP_BY_FARM,
  TREE_GROUP_BY_VIEW_LABELS,
} from 'constants/uiConstants';
import { TreeGroupBy } from 'utils/FarmUtils';
import MergeClassNames from 'utils/MergeClassNames';

const OPTIONS: { value: TreeGroupBy; Icon: React.ElementType }[] = [
  { value: TREE_GROUP_BY_FARM, Icon: PiTractor },
  { value: TREE_GROUP_BY_CROP, Icon: PiPlant },
];

interface CopyTreeGroupByToggleProps {
  /** Source or Destination, naming the group. */
  side: string;
  value: TreeGroupBy;
  onChange: (value: TreeGroupBy) => void;
}

/** Farm / Crop view icons, styled as the sidebar tree's (TreeViewControls). */
const CopyTreeGroupByToggle: React.FC<CopyTreeGroupByToggleProps> = ({
  side,
  value,
  onChange,
}) => (
  <div
    role="group"
    aria-label={COPY_TOOL_GROUP_BY_ARIA_LABEL(side)}
    className="flex flex-shrink-0 items-center gap-0.5"
  >
    {OPTIONS.map(({ value: option, Icon }) => {
      const label = TREE_GROUP_BY_VIEW_LABELS[option];
      const isActive = value === option;
      return (
        <Tooltip key={option} title={label} placement="bottom">
          <button
            type="button"
            aria-label={label}
            aria-pressed={isActive}
            className={MergeClassNames(
              'flex h-6 w-6 items-center justify-center rounded transition-colors',
              isActive
                ? 'border border-b-4 border-success bg-white text-success'
                : 'text-gray-muted hover:text-gray-dark'
            )}
            onClick={() => onChange(option)}
          >
            <Icon size={16} aria-hidden />
          </button>
        </Tooltip>
      );
    })}
  </div>
);

export default CopyTreeGroupByToggle;
